<div class="connectors">
  <div class="connectors__group" *ngIf="isLoading" aria-busy="true" aria-label="Carregando serviços">
    <span class="connectors__skeleton-label"></span>
    <div class="connectors__list">
      <div class="connectors__skeleton-row" *ngFor="let i of skeletonCards">
        <span class="connectors__skeleton-logo"></span>
        <span class="connectors__skeleton-lines">
          <span class="connectors__skeleton-line connectors__skeleton-line--name"></span>
          <span class="connectors__skeleton-line connectors__skeleton-line--desc"></span>
        </span>
        <span class="connectors__skeleton-action"></span>
      </div>
    </div>
  </div>

  <p class="connectors__feedback" *ngIf="!isLoading && !cards.length">
    Nenhum serviço encontrado.
  </p>

  <ng-container *ngIf="!isLoading">
    <div class="connectors__group" *ngFor="let group of groups">
      <div class="connectors__group-header">
        <span class="connectors__group-label">{{ group.label }}</span>
        <span class="connectors__group-count">{{ group.items.length }}</span>
      </div>

      <div class="connectors__list">
        <div class="connectors__row" *ngFor="let card of group.items">
          <span class="connectors__logo">
            <img
              *ngIf="card.connector.logoUrl; else logoFallback"
              [src]="card.connector.logoUrl"
              [alt]="card.connector.name"
            />
            <ng-template #logoFallback>
              <span class="connectors__logo-initial">{{ card.connector.name.charAt(0) }}</span>
            </ng-template>
          </span>

          <div class="connectors__info">
            <span class="connectors__name">{{ card.connector.name }}</span>
            <span class="connectors__description">{{ card.connector.description }}</span>
          </div>

          <button
            type="button"
            class="connectors__action"
            [class.connectors__action--connected]="card.isConnected"
            [disabled]="card.isBusy"
            (click)="card.isConnected ? disconnect(card) : connect(card)"
          >
            <i
              *ngIf="card.isBusy"
              class="fas fa-spinner fa-spin connectors__action-spinner"
              aria-hidden="true"
            ></i>
            <span>{{ actionLabel(card) }}</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
